/* eslint-disable no-restricted-imports */
import { Box, Divider, Stack, Typography } from '@mui/material';
import StarsIcon from '@mui/icons-material/Stars';
import { formatPrice } from 'integration/utils/formatPrice';

interface DpvaleSelectedCardProps {
	distributorName: string;
	recurrent: boolean;
	amount: number | string;
}

export const DpvaleSelectedCard = ({
	distributorName,
	recurrent,
	amount,
}: DpvaleSelectedCardProps) => (
	<Box
		sx={{
			display: 'flex',
			justifyContent: { xs: 'flex-start', md: 'space-around' },
			flexDirection: { xs: 'column', md: 'row' },
			gap: 1,
			width: '100%',
			backgroundColor: '#FFFFFF',
			border: '1px solid #ECECEC',
			borderRadius: '5px',
			paddingX: { xs: 0, md: 1 },
			paddingY: { xs: 1.5, md: 2 },
		}}
	>
		<Stack
			sx={{
				paddingX: 2,
				alignItems: { xs: 'flex-start', md: 'center' },
			}}
		>
			<Typography
				sx={{
					color: '#707070',
					fontSize: 'var(--font-size-small)',
				}}
			>
				{'Distribuidor'}
			</Typography>
			<Typography
				sx={{
					fontSize: 'var(--font-size-md)',
					color: '#000000',
					fontWeight: 'bold',
					WebkitLineClamp: 1,
					display: '-webkit-box',
					WebkitBoxOrient: 'vertical',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
			>
				{distributorName}
			</Typography>
		</Stack>
		<Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'block' } }} />
		<Divider
			orientation="horizontal"
			flexItem
			sx={{ display: { xs: 'block', md: 'none' }, marginX: 2 }}
		/>
		<Stack
			sx={{
				paddingX: 2,
				alignItems: { xs: 'flex-start', md: 'center' },
			}}
		>
			<Typography
				sx={{
					color: '#707070',
					fontSize: 'var(--font-size-small)',
				}}
			>
				{recurrent ? 'Crédito midp' : 'dpvale'}
			</Typography>
			<Typography
				sx={{
					display: 'flex',
					alignItems: { xs: 'flex-start', md: 'center' },
					fontSize: 'var(--font-size-md)',
					color: 'primary.main',
					fontWeight: 'bold',
					gap: 0.5,
				}}
			>
				<StarsIcon
					sx={{
						fontSize: 'var(--font-size-md)',
						alignSelf: 'center',
					}}
				/>
				{`${formatPrice(amount.toString(), 'MXN')}`}
			</Typography>
		</Stack>
	</Box>
);
